import FondBarChart from "../Fonds/FondBarChart";

import { useLookupFondsQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";
import { Fragment } from "react/jsx-runtime";
import './FondsCharts.scss'
function FondsCharts() {
  const { data, error, isLoading } = useLookupFondsQuery({r:{perso:0}});
  const {translate}=useTrads();

  return (
    error ? (
        <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

    ) : isLoading ? (
        <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> 
    ) : data ? (
    
      <div>
        <h3>Fonds</h3>
      <div className="chart-grid">
        
        {data.data.map(fond=>(
          <Fragment key={fond.id}>
          {(fond.solde>0)?
          <>
              
              <FondBarChart fond={fond} />
              </>
          :null}
          </Fragment>
        )
        )}
      </div>
      </div>
    
    ):null
  );
}

export default FondsCharts;